const volunteerAssignment = {
  title: "Ehrenamtliche Zuweisung",
  description:
    "Geben Sie den Akt für eine ehrenamtliche Mitarbeiter:in frei. Die freigegebene Person erhält Einsicht in diesen Kundenakt.",
  volunteerLabel: "Ehrenamtliche/r Mitarbeiter:in",
  assignButton: "Akt freigeben",
  replaceButton: "Freigabe übertragen",
  revokeButton: "Freigabe zurücknehmen",
  revokeConfirm: {
    title: "Freigabe zurücknehmen",
    text: "Möchten Sie die Freigabe für {{name}} wirklich zurücknehmen? Die Person verliert damit den Zugriff auf diesen Kundenakt.",
    confirm: "Zurücknehmen",
  },
  replaceConfirm: {
    title: "Freigabe übertragen",
    text: "Möchten Sie die Freigabe wirklich auf {{name}} übertragen? Die bisher freigegebene Person verliert damit den Zugriff auf diesen Kundenakt.",
    confirm: "Übertragen",
  },
  loading: "Freigabe wird geladen",
  loadError: "Die Freigabe konnte nicht geladen werden.",
  assignSuccess: "Der Akt wurde freigegeben.",
  assignError: "Der Akt konnte nicht freigegeben werden.",
  revokeSuccess: "Die Freigabe wurde zurückgenommen.",
  revokeError: "Die Freigabe konnte nicht zurückgenommen werden.",
};

export default volunteerAssignment;
